/* eslint-disable max-len */
import React from 'react'
import PropTypes from 'prop-types'
import Image from '@boltui/image'
import getSiteSection from '../../helpers/getSiteSection'
import styles from './Logo.scss'

const logoUrl = 'https://media.4rgos.it/i/Argos/logo_argos2x'
const href = `/?clickOrigin=header:${getSiteSection()}argos+logo`

const handleHomepageRoute = (evt, routes) => {
  if (routes.homepage && typeof routes.homepage === 'function') {
    evt.preventDefault()
    routes.homepage.call(this, href)
  }
}

const Logo = ({ routes }) => (
  <div className={styles.logoContainer}>
    <a
      className={styles.logo}
      href={href}
      data-el='header-logo'
      tabIndex='1'
      aria-label='Argos Logo - Load homepage'
      data-test={'header-logo'}
      onClick={(evt) => handleHomepageRoute(evt, routes)}>
      <Image width='120' src={logoUrl} fallbackFmt='fmt=png' alt='Argos Logo - Load homepage' />

      <span id='argos-logo' className='sr-only' aria-hidden={true}>
        Argos Logo - Load homepage
      </span>
    </a>
  </div>
)

Logo.propTypes = {
  routes: PropTypes.shape({
    help: PropTypes.func,
    stores: PropTypes.func,
    'advice-and-inspiration': PropTypes.func,
    search: PropTypes.func,
    megaButtons: PropTypes.arrayOf(PropTypes.func),
  }),
}

Logo.defaultProps = {
  routes: {},
}

export default Logo
